import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/noto-serif-sc/400.css';
import '@fontsource/noto-serif-sc/600.css';
import '@fontsource/noto-serif-sc/700.css';
import './styles/tokens.css';
import './index.css';
import App from './App';
import { applyTheme, getSavedTheme } from './styles/themes';

// 渲染前先套用已保存主题，避免首帧闪默认色
applyTheme(getSavedTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

